import cx from 'classnames';
import { Location } from 'history';
import { GroupsMenu } from 'mk2/components/GroupsMenu';
import { Panel } from 'mk2/components/Panel';
import { MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import { getPageHeaderState, getRequestDeviceMobile, getRequestPermissions, AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import styles from './LeftMenu.mscss';

interface OwnProps {
    className?: string;
    location: Location;
    section?: string;
}

interface StateProps {
    feedMenu: MenuItem[];
    isMobile: boolean;
    requestUserPermissions: string[];
}

type Props = OwnProps & StateProps;

export class LeftMenu extends React.PureComponent<Props> {

    public static defaultProps: Partial<OwnProps> = {
        section: 'forum_and_groups',
    };

    public render() {
        const {
            className, feedMenu, location, isMobile, requestUserPermissions, section,
        } = this.props;

        if (isMobile) {
            return null;
        }

        return (
            <Panel className={cx(styles.LeftMenu, className)}>
                <GroupsMenu
                    feedMenu={feedMenu}
                    currentUrl={`${location.pathname}${location.search}`}
                    isMobile={false}
                    requestUserPermissions={requestUserPermissions}
                    section={section}
                />
            </Panel>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        feedMenu: getPageHeaderState(state).feedMenu,
        isMobile: getRequestDeviceMobile(state),
        requestUserPermissions: getRequestPermissions(state),
    };
}

export default connect(mapStateToProps)(LeftMenu);
